// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-dialog-body-dialog {
  width: 100%;
  height: 100%;

  padding: 10px 10px 5px 10px;
  background-color: var(--background-color-4);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.service-dialog-body-dialog .container-icon-type-dialog {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

.service-dialog-body-dialog .container-icon-type-dialog .icon {
  width: 35px;
  height: 35px;
}

.service-dialog-body-dialog .container-content-type-dialog .content-header {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dialog/serviceDialog.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;;EAEZ,2BAA2B;EAC3B,2CAA2C;EAC3C,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".service-dialog-body-dialog {\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  padding: 10px 10px 5px 10px;\r\n  background-color: var(--background-color-4);\r\n  border-bottom-left-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n\r\n.service-dialog-body-dialog .container-icon-type-dialog {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 5px;\r\n}\r\n\r\n.service-dialog-body-dialog .container-icon-type-dialog .icon {\r\n  width: 35px;\r\n  height: 35px;\r\n}\r\n\r\n.service-dialog-body-dialog .container-content-type-dialog .content-header {\r\n  font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
